import gsap from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

export default function pageNavigation() {
	// Window hash scroll
	let window_scroll_location = window.location.hash;
	
	if ( window_scroll_location ) {
		// Reset scroll position to 0, 0
		setTimeout(function() {
			window.scrollTo(0, 0);
		}, 1);

		let scroll_element = document.querySelector(window_scroll_location);

		if ( scroll_element ) {
			gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

			// Run this after the page loads
			window.addEventListener('load', (event) => {
				let scroll_point = scroll_element.offsetTop - 32;
				gsap.to(window, {scrollTo: scroll_point});
			});
		}
	}
	
	// Page Navigation
	let page_nav_sections = document.querySelectorAll('.page-nav-section');

	if ( page_nav_sections.length ) {
		gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

		gsap.set(".page-nav-section", { zIndex: (i, target, targets) => targets.length - i });

		const navItems = gsap.utils.toArray("#page-nav li");
		const navLinks = gsap.utils.toArray("#page-nav a");
		const pageNav  = document.getElementById('page-nav');
		navItems.forEach((item, i) => {
			let item_link = item.querySelector('a');

			item_link.addEventListener("click", e => {
				let link_section = document.querySelector(e.currentTarget.getAttribute('href'));
				
				let scroll_point = (link_section[0].offsetTop + link_section.clientHeight);
				
				e.preventDefault();
				gsap.to(window, {scrollTo: scroll_point});
			});
		});

		const panels = gsap.utils.toArray(".page-nav-section");
		panels.forEach((panel, i) => {
			ScrollTrigger.create({
				start: 'top bottom+=100px',
				end: (panel.offsetTop + panel.clientHeight) - pageNav.clientHeight,
				onLeave: () => {
					if(navItems[i + 1]) {
						navItems[i + 1].classList.add('active');
						navItems[i].classList.remove('active');
					}
				}, 
				onEnterBack: () => {
					navItems[i].classList.add('active');
					if(navItems[i + 1]) {
						navItems[i + 1].classList.remove('active');
					}
				}, 
			})
		});
	}

}